import {Directive, ElementRef, Input, Output, OnChanges, EventEmitter, HostBinding, HostListener} from '@angular/core';
import {NotificationsService} from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
declare const google: any;
declare let googleLoaded: any;
declare const googleChartsPackagesToLoad: any;
@Directive({
  selector: '[GoogleChart]'
})
export class GoogleChart implements OnChanges {
  public _element: any;
  @Input('chartType') public chartType: string;
  @Input('chartOptions') public chartOptions: Object;
  @Input('loadingDelay') public loadingDelay = 0;
  @Input('chartData') public chartData: Object;
  @Output('itemSelect') public itemSelect: EventEmitter<{ row: number, column: number }> = new EventEmitter();
  @Output('itemDeselect') public itemDeselect: EventEmitter<void> = new EventEmitter<void>();
  @Output('error') public error: EventEmitter<any> = new EventEmitter<any>();

  constructor(public element: ElementRef, private translate: TranslateService, private notifications: NotificationsService) {
    this._element = this.element.nativeElement;
  }

  ngOnChanges() {
  	if(typeof google === 'undefined') {
  		this.notifications.error(this.translate.instant('common.errorGoogle'));
  	} else {
	    if (!googleLoaded) {
	     	googleLoaded = true;
	      	google.charts.load('current', {'packages': ['corechart', 'gauge']['orgchart'], 'language': window.localStorage.getItem('lang')});
	    }                  
	    setTimeout(() => this.drawGraph(this.chartOptions, this.chartType, this.chartData, this._element), this.loadingDelay);
   	}
  }

  @HostListener('window:resize') onResize(event: Event) {
    this.drawGraph(this.chartOptions, this.chartType, this.chartData, this._element);
  }

  drawGraph(chartOptions, chartType, chartData, ele) {
    google.charts.setOnLoadCallback(drawChart);

    const self = this;

      function applyFormatters(table) {
          const options = self.chartOptions;

          if (options['hAxes']) {
              for (let key in Object.keys(options['hAxes'])) {
                  let axis = options['hAxes'][key];
                  if (axis.formatter) {
                      let formatter = axis.formatter;
                      if (formatter == 'minsToHours') {
                          formatter =  getNewDurationFormatter();
                      }
                      formatter.format(table, Number(key) + 1);
                  }
              }
          }
      }

      function getNewDurationFormatter() {
         
          const DurationFormatter = function () {
          };
          DurationFormatter.prototype.format = function (dt, column) {
              for (let i = 0; i < dt.getNumberOfRows(); i++) {
                  const value = dt.getValue(i, column);
                  const hours = Math.floor(value / 60);
                  const mins = value % 60;
                  const formattedValue = self.translate.instant('msgs.minsToHours', {hours, minutes: mins.toFixed(0)});
                //   const formattedValue = '  ' + hours + ' hrs ' + mins.toFixed(0) + ' mins  ';
                  dt.setFormattedValue(i, column, formattedValue);
              }
          };
          return new DurationFormatter();
      }

      function getViewColumns(header) {
          let columns = [];
          const options = self.chartOptions;
          if (options['showAnnotations']) {
              columns = getAnnotations(header);
          } else {
              for (let i = 0; i < header.length; i++) {
                  columns.push(i);
              }
          }
          return columns;
      }

      function getAnnotations(headerRow) {
          const annotations: Array<any> = [0];
          for (let i = 1; i < headerRow.length; i++) {
              annotations.push(i);
              annotations.push({
                  calc: 'stringify',
                  sourceColumn: i,
                  type: 'string',
                  role: 'annotation' });
          }
          return annotations;
      }

      function drawChart() {
        chartOptions.annotations = {
            alwaysOutside: true,
            textStyle: {
                bold: false,
                italic: false,
                // The color of the text.
                color: '#000000',
            //     // The color of the text outline.
            //     auraColor: '#f2f2f2'
            }
        };
        const data = google.visualization.arrayToDataTable(chartData);
        applyFormatters(data);
        const columns = getViewColumns(chartData[0]);
        const view = new google.visualization.DataView(data);
        view.setColumns(columns);

        const wrapper = new google.visualization.ChartWrapper({
            chartType: chartType,
            dataTable: view,
            options: chartOptions || {}
        });

        google.visualization.events.addListener(wrapper, 'error', function (err) {
            self.error.emit(err);
        });

        wrapper.draw(ele);

        google.visualization.events.addListener(wrapper, 'select', function () {
            const selectedItem = wrapper.getChart().getSelection()[0];
            if (selectedItem) {
              let msg;
              if (selectedItem !== undefined) {
                const selectedRowValues = [];
                if (selectedItem.row !== null) {
                  selectedRowValues.push(wrapper.getDataTable().getValue(selectedItem.row, 0));
                  if (selectedItem.column) {
                      selectedRowValues.push(wrapper.getDataTable().getValue(selectedItem.row, selectedItem.column));
                  }
                  msg = {
                    message: 'select',
                    row: selectedItem.row,
                    column: selectedItem.column,
                    selectedRowValues: selectedRowValues
                  };
                }
              }
              self.itemSelect.emit(msg);
            } else {
                self.itemDeselect.emit();
            }
        });
    }
  }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/helper/google-chart.component.ts